import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { HeaderService } from '@app/core/services/header.service';
import { ModalService } from '@app/core/services/modal.service';
import { ChargeInformationDto, DashboardQueryFailedAutomationsResultDto, DashboardService, } from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { TableComponent } from '@shared/components/table/table.component';
import { failedAutomationsTable } from '@shared/table-configs/dashboard/failed-automations.table';
import { SortParam } from '@app/core/constants/sort-param';
import { Trash } from 'lucide-angular';
import {
  DashboardRemoveFailedAutomationComponent
} from '@shared/modals/dashboard/query/dashboard-remove-failed-automation/dashboard-remove-failed-automation.component';

@Component({
  selector: 'app-dashboard-waiting-price',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-waiting-price.component.html',
  styleUrl: './dashboard-waiting-price.component.css'
})
export class DashboardWaitingPriceComponent implements AfterViewInit {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;
  public tableData: ChargeInformationDto[] = [];
  public tableConfig: TableConfig<DashboardQueryFailedAutomationsResultDto> = {
    ...failedAutomationsTable,
    serviceCallback: (pageSize: number, page: number, sort?: SortParam) =>
      this.dashboardService.dashboardQueryFailedAutomationsPost({ pageSize, page }),
    contextActions: [
      {
        id: 'remove',
        title: 'common.remove',
        icon: Trash,
        callback: () => this.openRemoveModal(),
        disabled: () => this.selectedElements.length === 0,
      },
    ],
  };

  public selectedElements: DashboardQueryFailedAutomationsResultDto[] = [];

  constructor(
    private readonly headerService: HeaderService,
    private readonly dashboardService: DashboardService,
    private readonly modalService: ModalService,
  ) {
    this.headerService.setTitle('dashboard.query.failedautomations.title');
    this.headerService.setActions(
      [{ id: 'remove', title: 'common.remove', icon: Trash }],
      { remove: () => this.openRemoveModal() },
      { remove: () => this.selectedElements.length === 0 },
    );
  }

  public ngAfterViewInit(): void {
    this.table?.search();
  }

  private openRemoveModal(): void {
    this.modalService.show({
      title: 'dashboard.remove.title',
      component: DashboardRemoveFailedAutomationComponent,
      type: 'center',
      actions: [
        { type: 'primary', label: 'system.button.ok', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: {
        elements: this.selectedElements,
      },
    }).subscribe(() => {
      this.table?.search();
    });
  }
}
